import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'
import { Label } from '@/components/ui/label'
import TimePicker from './time_picker'

// Inline calendar + time field (react-day-picker v10), replacing the jQuery
// bootstrap-datetime-picker widget. Same public API as before: `value` is any
// moment-parseable datetime and `onChange` fires on every date/time change
// with the exact format the legacy picker emitted:
// moment(...).format('YYYY-MM-DDTHH:mm:00.000Z'), e.g.
// "2026-06-10T14:30:00.000+02:00". The legacy `show`/`startView` props are
// accepted but no-ops — the calendar is always visible, like the old inline
// widget.
const VALUE_FORMAT = 'YYYY-MM-DDTHH:mm:00.000Z'

const DatetimePicker = ({ value, onChange }) => {
  const initial = value ? moment(value) : moment().startOf('hour')
  const [date, setDate] = useState(initial.toDate())
  const [time, setTime] = useState(initial.format('HH:mm'))

  // Re-sync when the parent passes a new value
  useEffect(() => {
    if (value) {
      const m = moment(value)
      if (m.isValid()) {
        setDate(m.toDate())
        setTime(m.format('HH:mm'))
      }
    }
  }, [value])

  const emit = (nextDate, nextTime) => {
    const [hours, minutes] = nextTime.split(':').map(Number)
    const combined = moment(nextDate).hours(hours || 0).minutes(minutes || 0)
    onChange(combined.format(VALUE_FORMAT))
  }

  const onDaySelect = (day) => {
    if (day) {
      setDate(day)
      emit(day, time)
    }
  }

  const onTimeChange = (next) => {
    setTime(next)
    if (next) {
      emit(date, next)
    }
  }

  return (
    <div>
      <DayPicker
        mode="single"
        selected={date}
        onSelect={onDaySelect}
        defaultMonth={date}
        showOutsideDays={false}
      />
      <div className="mt-2 flex items-center gap-3 border-t pt-3">
        <Label className="text-sm">Time</Label>
        <TimePicker value={time} onChange={onTimeChange} />
      </div>
    </div>
  )
}

export default DatetimePicker
